import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { subscribeNotifications } from '@/api/auth';
import { onMounted, ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'NotificationSetup',
    setup: function (__props) {
        var isSubscribed = ref(false);
        onMounted(function () {
            initPush();
        });
        function urlBase64ToUint8Array(base64String) {
            var padding = '='.repeat((4 - (base64String.length % 4)) % 4);
            var base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
            var rawData = atob(base64);
            return Uint8Array.from(Array.from(rawData).map(function (c) { return c.charCodeAt(0); }));
        }
        function initPush() {
            return __awaiter(this, void 0, void 0, function () {
                var permission, VAPID_PUBLIC_KEY, registration, subscription;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!('serviceWorker' in navigator)) {
                                alert('Este navegador no soporta Service Workers');
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, Notification.requestPermission()];
                        case 1:
                            permission = _a.sent();
                            if (permission !== 'granted') {
                                alert('No se otorgaron permisos para notificaciones');
                                return [2 /*return*/];
                            }
                            VAPID_PUBLIC_KEY = process.env.VUE_APP_NOT_PUBLIC_KEY;
                            return [4 /*yield*/, navigator.serviceWorker.register('/service-worker.js')];
                        case 2:
                            registration = _a.sent();
                            console.log('SW registrado:', registration);
                            return [4 /*yield*/, registration.pushManager.subscribe({
                                    userVisibleOnly: true,
                                    applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
                                })];
                        case 3:
                            subscription = _a.sent();
                            subscribeNotifications(subscription);
                            console.log('🎯 Suscripción push generada:', subscription);
                            isSubscribed.value = true;
                            return [2 /*return*/];
                    }
                });
            });
        }
        return function () { };
    }
});
